import { Imprint } from "../features/imprint/Imprint";
import { SimplePage } from "../features/simplePage/SimplePage";

export const ImprintPage: React.FC = () => (
  <SimplePage>
    <Imprint />
  </SimplePage>
);
